
            import * as GameModule from "/src/standalone.ts";
            import { bootIframeRunner } from "@universe/game-runner";

            const loader = {
              resolveEntry: () => GameModule
            };

            bootIframeRunner(loader, {
              isDev: import.meta.env.DEV,
              fallbackTitle: (id) => `Universe & More – ${id}`
            });
          